import { Action } from '@ngrx/store';
import Theme from '../interfaces/theme.interface';
import { ActionTypes } from '../models/actionTypes';

export const ChangeTheme = (theme: Theme) => {
  return <Action>{ type: ActionTypes.ChangeTheme, payload: theme };
};
